import { adminOrganizationSchema, adminUserSchema, pageSchema } from '@crm/contracts';
import { queryOptions } from '@tanstack/react-query';

import { request } from '@/shared/api';

/** The gateway has no search or totals: the admin pages load one large page and filter it. */
const PAGE = 100;

export const platformKeys = {
  users: ['platform', 'users'] as const,
  organizations: ['platform', 'organizations'] as const,
};

export const platformUsersQuery = queryOptions({
  queryKey: platformKeys.users,
  queryFn: ({ signal }) =>
    request('GET', `/admin/users?limit=${PAGE}`, { schema: pageSchema(adminUserSchema), signal }),
  select: (page) => page.items,
});

export const platformOrganizationsQuery = queryOptions({
  queryKey: platformKeys.organizations,
  queryFn: ({ signal }) =>
    request('GET', `/admin/organizations?limit=${PAGE}`, {
      schema: pageSchema(adminOrganizationSchema),
      signal,
    }),
  select: (page) => page.items,
});
